module.exports = "/assets/logo_sg_speedgrade-6f536e672ed5ef9b78347e4d18991ca5.png";